export enum NoteType {
    CONTACT = 1
}